export default __webpack_public_path__ + "static/media/trash.a864b6b6.svg";